import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, TransitionGroup as _TransitionGroup, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, withDefaults } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomTransition',
  props: {
    delay: { type: Boolean },
    horizontal: { type: Boolean },
    mode: { default: 'translate' },
    speed: { default: 'normal' },
    multiple: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { delay?: boolean, horizontal?: boolean, mode: 'scale' | 'translate', speed: 'fast' | 'normal' | 'slow', multiple: boolean }



const translationHiding = computed(() =>
  props.horizontal ? 'translate-x-full' : 'translate-y-full'
)
const showing = computed(() => {
  if (props.mode === 'scale') return 'scale-100'
  return props.horizontal ? 'translate-x-0' : 'translate-y-0'
})
const speed = computed(() => {
  switch (props.speed) {
    case 'fast':
      return 'duration-150'
    default:
    case 'normal':
      return 'duration-300'
    case 'slow':
      return 'duration-450'
  }
})
const enterActive = computed(() => {
  let mode = ''
  if (props.mode === 'translate') mode = translationHiding.value
  const res = [speed.value, 'ease-in', mode]
  if (props.delay) res.push('delay-150')
  return res.filter(Boolean).join(' ')
})
const hiding = computed(() => {
  const res = ['opacity-0']
  switch (props.mode) {
    case 'translate':
      res.push(translationHiding.value)
      break
    case 'scale':
      res.push('scale-75')
  }
  return res.join(' ')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_TransitionGroup, {
    "enter-active-class": _unref(enterActive),
    "enter-from-class": _unref(hiding),
    "enter-to-class": _unref(showing),
    "leave-to-class": _unref(hiding)
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["enter-active-class", "enter-from-class", "enter-to-class", "leave-to-class"]))
}
}

})